import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  useBreakpointValue,
} from "@chakra-ui/react";

import { useRef, useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getAddressObject = (addressComponents: any) => {
  const ShouldBeComponent: any = {
    street_number: ["street_number", "sublocality_level_3"],
    postal_code: ["postal_code"],
    street: ["street_address", "route"],
    state: [
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "administrative_area_level_4",
      "administrative_area_level_5",
    ],
    city: [
      "locality",
      "sublocality",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "sublocality_level_4",
    ],
    country: ["country"],
  };

  const address: any = {
    street_number: "",
    postal_code: "",
    street: "",
    state: "",
    city: "",
    country: "",
  };

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (addressComponents)
    addressComponents.forEach((component: any) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const shouldBe in ShouldBeComponent) {
        if (ShouldBeComponent[shouldBe]?.indexOf(component.types?.[0]) !== -1) {
          if (shouldBe === "country") {
            address[shouldBe] = component.short_name;
          } else {
            address[shouldBe] = component.long_name;
          }
        }
      }
    });

  // Fix the shape to match our schema
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  address.address = `${address.street_number} ${address.street}`;
  delete address.street_number;
  delete address.street;
  return address;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const AddressAutocompleteTextfield = (props: any) => {
  const {
    label,
    variant,
    error,
    helperText,
    className,
    peronsalAddress,
    required,
    fullWidth,
    handleGoogleAddress,
    defaultValue,
    placeholder,
    handleManualStreetAddress,
    disabled,
    defaultValueUpdatedAt,
    ...restOfTextFieldProps
  } = props;
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const [value, setValue] = useState(defaultValue || null);
  const isMobile: boolean = useBreakpointValue({
    base: true,
    md: false,
  }) as boolean;
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_PLACES_KEY,
    onPlaceSelected: (place) => {
      const formattedAddress = getAddressObject(place?.address_components);
      const latitude = place?.geometry?.location?.lat();
      const longitude = place?.geometry?.location?.lng();
      handleGoogleAddress({
        ...formattedAddress,
        formatted_address: place.formatted_address,
        latitude,
        longitude,
      });
      setValue(formattedAddress.address);
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: "us" },
    },
    inputAutocompleteValue: "new-password", // Example usage, adjust as needed
  });

  return (
    <>
      <style>
        {`
      .pac-container {
        z-index: 10000 !important;
      }
    `}
      </style>
      <FormControl
        className={className}
        isRequired={required}
        isInvalid={error}
        isDisabled={disabled}
      >
        <FormLabel
          color="teal.900"
          fontWeight="700"
          fontSize={[14, 14, 18, 24]}
          htmlFor="firstName"
          m={isMobile ? "initial" : ""}
        >
          {label}
        </FormLabel>
        <Input
          id="address-input"
          value={value}
          placeholder={placeholder}
          borderBottomWidth="2px"
          borderBottomColor="hjsBlack"
          focusBorderColor="yellow.500"
          errorBorderColor="red.500"
          fontSize={[14, 14, 18]}
          height={isMobile ? 8 : 10}
          onChange={(event: any) => {
            handleManualStreetAddress(event.target.value);
            setValue(event.target.value);
          }}
          variant={"flushed"}
          ref={ref as unknown as React.LegacyRef<HTMLInputElement>}
        />
        {Boolean(error) && (
          <FormErrorMessage fontSize={[14, 14, 18]}>
            {helperText}
          </FormErrorMessage>
        )}
      </FormControl>
    </>
  );
};

AddressAutocompleteTextfield.defaultProps = {
  label: "",
  variant: "standard",
  type: "text",
  error: false,
  helperText: "",
  className: null,
  required: false,
  fullWidth: true,
  size: "small",
  disabled: false,
  defaultValue: "",
};

export default AddressAutocompleteTextfield;
